module.exports = __webpack_public_path__ + "34aafa17b0aea8343d8d15cc75eeed6c.jpg";